module.exports = __webpack_public_path__ + "media/images/product-details-bg-77ff53779994729c32f13fd10a564080.jpg";